import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getSingleEmployee } from '../../redux/actions/employee';
import { deactivatedUser, activatedUser } from '../../redux/actions/user';

import EmployeeDetailPage from './EmployeeDetail.page';

const mapStateToProps = state => ({
  employeeDetail: state.organization.detailEmployee,
  loading: state.organization.loading,
  error: state.organization.error,
  me: state.auth.me,
});

const mapDispatchToProps = {
  activatedUser,
  deactivatedUser,
  getSingleEmployee,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(EmployeeDetailPage));
